<div class="persona-choice" *ngIf="ready">
  <se-fe-header
    [ngClass]="{ 'missing-info': missingInfo }"
    (click)="handleHeaderClick($event)"
    (keydown)="onKeydown($event)" tabindex="0"
    class="persona-header se-fe-theme--interactive"
    [seFeDataTitle]="profile?.persona?.full_name"
    [seFeDataSubtitle]="subtitle"
    [seFeDataLevel]="0"
    [seFeDataSize]="600">
    <se-fe-avatar
      seFeHeaderVisual
      seFeDataType="persona"
      [seFeDataIdentity]="profile?.persona?.full_name"
      [seFeDataImgUrl]="imageUrl"
      [seFeDataSize]="300">
    </se-fe-avatar>
  </se-fe-header>
  <se-fe-button
    class="edit-button"
    (click)="onEdit($event)"
    seFeDataEmphasis="low">
    {{ 'SE_PO_UI_PERSONA_CHOICE.EDIT' | translate }}
  </se-fe-button>
</div>
